

























































import Vue from 'vue'

// interview report
import Report from '@/components/interviews/PostReport.vue'
import Artifacts from '@/components/artifacts/Artifacts.tsx'

export default Vue.extend({
  components: {
    Artifacts,
    Report,
  },
  created() {
    const feedbackInterviewReports: any[] = this.$store.getters[
      'feedbackInterviewReports/filterBy'
    ](this.where)

    // load all feedbackInterviewReports
    this.$store
      .dispatch({ type: 'feedbackInterviewReports/pullObjects', setLoading: false })
      .then(data => {
        console.debug('loaded interview reports', data)
        const feedbackInterviewReports: any[] = this.$store.getters[
          'feedbackInterviewReports/filterBy'
        ](this.where)
        // create a letter, if none exists. this avoids jumping between the two editors.
        if (feedbackInterviewReports.length === 0) {
          return this.$store
            .dispatch({
              type: 'feedbackInterviewReports/pushObject',
              object: { ...this.defaults },
            })
            .then(() => {
              window.alert('SORRY! Cockpit must reload. Please come back to this task afterwards.')
              location.reload()
            })
        }
      })
  },
  computed: {
    where(): object {
      return { case_id: this.caseId }
    },
    defaults(): object {
      return { ...this.where, interviewer_id: this.$store.getters.currentUserId }
    },
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: Object,
    },
    locale: {
      type: String,
      default(): string {
        return this.$i18n.locale
      },
    },
  },
})
